// Прогресс карточки «Get started» хранится отдельно для каждого аккаунта:
// ключ с id пользователя не даёт двум аккаунтам в одном браузере делить
// прогресс. Ключ переживает выход (см. clearStorageKeepingAppearance).
export const ONBOARDING_KEY_PREFIX = "taskpal.onboarding.";

export const onboardingKey = (userId) => `${ONBOARDING_KEY_PREFIX}${userId}`;

const VERSION = 3;

function storage() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

// v2 хранил один статус вместо отдельных флагов
function fromV2(value) {
  if (!["active", "completed", "hidden", "ineligible"].includes(value.status))
    return null;
  return {
    eligible: value.status != "ineligible",
    listId: typeof value.listId == "string" ? value.listId : null,
    taskDone: value.taskComplete === true,
    inviteDone: value.inviteComplete === true,
    hidden: value.status == "hidden",
    completed: value.status == "completed",
  };
}

// null — прогресса нет или он нечитаем
export function readOnboardingProgress(userId) {
  const ls = storage();
  if (!userId || !ls) return null;
  try {
    const value = JSON.parse(ls.getItem(onboardingKey(userId)));
    if (!value || typeof value != "object") return null;
    if (value.version != VERSION) return fromV2(value);
    return {
      eligible: typeof value.eligible == "boolean" ? value.eligible : null,
      listId: typeof value.listId == "string" ? value.listId : null,
      taskDone: value.taskDone === true,
      inviteDone: value.inviteDone === true,
      hidden: value.hidden === true,
      completed: value.completed === true,
    };
  } catch (e) {
    return null;
  }
}

export function writeOnboardingProgress(userId, progress) {
  const ls = storage();
  if (!userId || !ls) return;
  try {
    ls.setItem(
      onboardingKey(userId),
      JSON.stringify({
        version: VERSION,
        eligible: progress.eligible,
        listId: progress.listId,
        taskDone: progress.taskDone,
        inviteDone: progress.inviteDone,
        hidden: progress.hidden,
        completed: progress.completed,
      })
    );
  } catch (e) {
    // переполненный/выключенный localStorage не должен ломать приложение
  }
}
